import styled from "@emotion/styled";
import { TextareaAutosize, TextField, Typography, Button } from "@mui/material";
import dayjs from 'dayjs';
import * as yup from 'yup';
import 'dayjs/locale/it';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { useDispatch, useSelector } from "react-redux";
import { createSensore, fetchSensori, fetchSingleSensore, fetchWeatherData, updateSensore } from '../../../features/sensori/sensoriThunk';
import { useEffect, useState } from "react";
dayjs.locale('it');
const Textarea = styled(TextareaAutosize)`
    box-sizing: border-box;
    width: 100%;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 12px;
    border-radius: 5px;
    color: #160A2A;
    background: #fff;
    border: 2px solid #e5e5e5;
`;

// Updated EmptyTextarea Component
const EmptyTextarea = ({ placeholder, value, onChange }) => {
    const [inputValue, setInputValue] = useState(value || "");

    useEffect(() => {
        setInputValue(value || "");
    }, [value]);

    const handleChange = (event) => {
        setInputValue(event.target.value);
        onChange(event);
    };

    return (
        <Textarea
            aria-label="empty textarea"
            placeholder={placeholder}
            minRows={4}
            value={inputValue}
            onChange={handleChange}
        />
    );
};
const schema = yup.object().shape({
    sensore_name: yup.string().required("Sensore name è obbligatoria"),
    sensore_tipo: yup.string().required("Tipo è obbligatoria"),
    modelllo: yup.string().required("Modello è obbligatoria"),
    matricola: yup.string().required("Matricola è obbligatoria"),
    sensore_gps: yup.string().required("Posizione GPS è obbligatoria"),
    data_installazione: yup.date().required("Data installazione è obbligatoria").typeError("Formato data di installazione non valido"),
    ultimo_agginornamento: yup.date().required("Ultimo aggiornamento è obbligatoria").typeError("Formato data di ultimo aggiornamento non valido"),
    sensore_note: yup.string(),
});
const SensoriForm = ({ cantine, sensoreId, singleData, setCantine }) => {
    const dispatch = useDispatch();
    const { control, setValue, handleSubmit, formState: { errors }, reset } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            sensore_name: "",
            sensore_tipo: "",
            modelllo: "",
            matricola: "",
            sensore_gps: "",
            data_installazione: null,
            ultimo_agginornamento: null,
            sensore_note: ""
        }
    });
    useEffect(() => {
        if (singleData) {
            // console.log("Populating form with singleData:", singleData);
            setValue("sensore_name", singleData?.sensore_name || "");
            setValue("sensore_tipo", singleData?.sensore_tipo || "");
            setValue("modelllo", singleData?.modelllo || "");
            setValue("matricola", singleData?.matricola || "");
            setValue("sensore_gps", singleData?.sensore_gps || "");
            setValue(
                "data_installazione",
                singleData?.data_installazione ? dayjs(singleData.data_installazione) : null
            );
            setValue(
                "ultimo_agginornamento",
                singleData?.ultimo_agginornamento ? dayjs(singleData.ultimo_agginornamento) : null
            );
            setValue("sensore_note", singleData?.sensore_note || "");
        }
    }, [singleData, setValue]);
    const onSubmit = async (data) => {
        try {
            const sensoreData = {
                sensore_name: data.sensore_name,
                sensore_tipo: data.sensore_tipo,
                mezzi_id:localStorage.getItem('mezzi_id'),
                modelllo: data.modelllo,
                matricola: data.matricola,
                sensore_gps: data.sensore_gps,
                data_installazione: data.data_installazione ? dayjs(data.data_installazione).format("YYYY-MM-DD") : null,
                ultimo_agginornamento: data.ultimo_agginornamento ? dayjs(data.ultimo_agginornamento).format("YYYY-MM-DD") : null,
                sensore_note: data.sensore_note,
            };
            if (!cantine) {
                // Update existing sensore
                // console.log("Updating sensore with ID:", sensoreId);
                await dispatch(
                    updateSensore({
                        id: singleData.id,
                        data: sensoreData,
                    })
                ).unwrap();
                setCantine(false)
                // console.log("Sensore updated successfully!");
                dispatch(fetchWeatherData())
            } else {
                // Create new sensore
                // console.log("Creating new sensore");
                await dispatch(createSensore(sensoreData)).unwrap();
                setCantine(false)
                // console.log("Sensore created successfully!");
            }
            dispatch(fetchSensori());
            // reset();
        } catch (error) {
            console.error("Error:", error);
        }
    };
    // useEffect(() => {
    //     if (singleData) {
    //         reset(singleData);
    //     }
    // }, [singleData, reset]);
    return (
        <form className="AziendaFrom" onSubmit={handleSubmit(onSubmit)}>
        <div className="AziendaFrom__inner">
            {!sensoreId && <Typography mb={"10px"}>ID=0001</Typography>}
            <Controller
            defaultValue=""
                name="sensore_name"
                control={control}
                render={({ field }) => (
                    <TextField className="customTextBox" {...field} label="Nome" fullWidth margin="normal" error={!!errors.sensore_name} helperText={errors.sensore_name?.message || "The value should exactly match the device_id"} />
                )}
            />
            <Controller
            defaultValue=""
                name="sensore_tipo"
                control={control}
                render={({ field }) => (
                    <TextField className="customTextBox" {...field} label="Tipo" fullWidth margin="normal" error={!!errors.sensore_tipo} helperText={errors.sensore_tipo?.message} />
                )}
            />
            <Controller
            defaultValue=""
                name="modelllo"
                control={control}
                render={({ field }) => (
                    <TextField className="customTextBox" {...field} label="Modello" fullWidth margin="normal" error={!!errors.modelllo} helperText={errors.modelllo?.message} />
                )}
            />
            <Controller
            defaultValue=""
                name="matricola"
                control={control}
                render={({ field }) => (
                    <TextField className="customTextBox" {...field} label="Matricola" fullWidth margin="normal" error={!!errors.matricola} helperText={errors.matricola?.message} />
                )}
            />
            <Controller
            defaultValue=""
                name="sensore_gps"
                control={control}
                render={({ field }) => (
                    <TextField className="customTextBox" {...field} label="Posizione GPS" fullWidth margin="normal" error={!!errors.sensore_gps} helperText={errors.sensore_gps?.message} />
                )}
            />
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
                <Controller
                defaultValue=""
                    name="data_installazione"
                    control={control}
                    render={({ field }) => (
                        <DatePicker
                            label="Data Installazione"
                            className='datePickerField'
                            value={field.value}
                            onChange={(newValue) => field.onChange(newValue)}
                        />
                    )}
                />
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
                <Controller
                defaultValue=""
                    name="ultimo_agginornamento"
                    control={control}
                    render={({ field }) => (
                        <DatePicker
                            className='datePickerField'
                            label="Ultimo Aggiornamento"
                            value={field.value}
                            onChange={(newValue) => field.onChange(newValue)}
                        />
                    )}
                />
            </LocalizationProvider>
            <Controller
            defaultValue=""
                name="sensore_note"
                control={control}
                render={({ field }) => <EmptyTextarea placeholder="Note" {...field} />}
            />
            <div className="btnPart1">
                <Button type="submit" variant="contained">
                    Salva dati
                </Button>
            </div>
        </div>
    </form>
    );
};
export default SensoriForm;